<template>
  <div>
 <!--   <van-nav-bar
      title="精品甄选 铭普推荐"
      style="background-color:brown;"
    >

    </van-nav-bar> -->

  <!--  <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image"  style="width: 100%;height: 300px;" />
      </van-swipe-item>
    </van-swipe>
    <van-grid :column-num="3">
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
    </van-grid>
    <van-grid :column-num="3">
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
    </van-grid>
    <img :src="images[0]"  style="width: 100%;height: 150px;" />
    <van-grid :column-num="3">
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
      <van-grid-item icon="photo-o" text="文字" />
    </van-grid>
    <img :src="images[0]"  style="width: 100%;height: 400px;" />
    <span>铭普集团 </span> -->

    <van-card v-for="(item,index) in cplist"

      tag="品质精选"
      :key="item.name"
      :desc="htmlToString(escape2Html(item.desc))"
      :title="item.name"
      :thumb="item.mainpic[0]"
      @click="todetail(index)"
      :placeholder="true"
    />

  </div>
</template>

<script>
  import * as Api from './api.js'

  import jsonData from '../../../static/cp.json';
  export default {
    name: 'cplist',
    components:{},
    data () {
      return {
        cplist:[],

      }
    },
    created() {
      this.cplist = jsonData
      console.log(jsonData)
      console.log(this.escape2Html(this.cplist[0].desc))
    },
    methods:{
      todetail(index){
        this.$router.push({path:'/cpdetail',query:{index:index}})
      },
      escape2Html(str) {                            //转义字符转换普通字符的方法
           var arrEntities={'lt':'<','gt':'>','amp':'&','quot':'"'};
           return str.replace(/&(lt|gt|amp|quot);/ig,function(all,t){return arrEntities[t];}).replace(/&nbsp;/g,' ')
         },
      htmlToString(htmlStr){
      	return htmlStr.replace(/<\/?.+?\/?>|\r|\n|\s*/g,'')
      }

    }
  }

</script>

<style>
  .van-nav-bar__title{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/cplist/index.vue